import React from "react";

import InsightsSmall from "assets/images/icons/JSX/InsightsSmall";
import InsightsRoomByRoom from "assets/images/icons/JSX/InsightsRoomByRoom";
import InsightsEnergyPlus from "assets/images/icons/JSX/InsightsEnergyPlus";
import InsightsUtilityAnalysis from "assets/images/icons/JSX/InsightsUtilityAnalysis";
import EmbCGrade from "assets/images/icons/JSX/EmbCGrade";

const ICON_BLUE = "#0049C6";

const InsightsIcon = () => <InsightsSmall fill={ICON_BLUE} />;
const RoomByRoomIcon = () => <InsightsRoomByRoom />;
const EnergyPlusIcon = () => <InsightsEnergyPlus fill={ICON_BLUE} />;
const UtilityAnalysisIcon = () => <InsightsUtilityAnalysis fill={ICON_BLUE} />;
const EmbodiedCarbonIcon = () => <EmbCGrade fill={ICON_BLUE} />;

/** Slide config for the Volta SNAP 1.0.0 dashboard announcement. */
export const VERSION_ID = "1.0.0";

export const EYEBROW = "New in 1.0";

export const SLIDES = [
    {
        id: "launch",
        title: "Volta SNAP 1.0",
        description: "We're out of beta! Insights and a set of major new analysis tools are now live across the app.",
        cta: { label: "View updates", to: "/updates" },
        Icon: InsightsIcon,
    },
    {
        id: "insights",
        title: "Insights",
        description:
            "A dedicated home for Room-by-room, EnergyPlus, and Utility Analysis. Activate per model for 1 credit.",
        cta: { label: "Learn more", to: "/updates" },
        Icon: InsightsIcon,
    },
    {
        id: "room-by-room",
        title: "Room-by-room in Insights",
        description: "Redesigned F280 room-by-room workflow, free to use for a limited time after launch.",
        cta: { label: "Learn more", to: "/updates" },
        Icon: RoomByRoomIcon,
    },
    {
        id: "energy-plus",
        title: "EnergyPlus",
        description: "Run hourly EnergyPlus simulations in Insights. Free to use until April 2027.",
        cta: { label: "Learn more", to: "/updates" },
        Icon: EnergyPlusIcon,
        forceIconBlue: true,
    },
    {
        id: "parametric-analysis",
        title: "Parametric Analysis",
        description:
            "Now available for all users through the credit system. Each credit unlocks a batch of 2,500 parametric runs.",
        cta: { label: "Learn more", to: "/updates" },
        Icon: EmbodiedCarbonIcon,
    },
    {
        id: "utility-analysis",
        title: "Utility Analysis",
        description:
            "Compare utility data to your energy model and run demonstrated load analysis. Free to use until April 2027.",
        cta: { label: "Learn more", to: "/updates" },
        Icon: UtilityAnalysisIcon,
        forceIconBlue: true,
    },
    {
        id: "embodied-carbon",
        title: "Embodied carbon",
        description: "Automatic embodied carbon estimates as you build your model, with results in Review.",
        cta: { label: "Learn more", to: "/updates" },
        Icon: EmbodiedCarbonIcon,
    },
];
